export const defaultViewport = { once: false, amount: 0.2, margin: '0px 0px -8% 0px' };

export const animationVariants = {
  fadeIn: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
    },
  },

  slideUp: {
    hidden: { opacity: 0, y: 28 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
    },
  },

  slideDown: {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
    },
  },

  slideRight: {
    hidden: { opacity: 0, x: -36 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
    },
  },

  slideLeft: {
    hidden: { opacity: 0, x: 36 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
    },
  },

  scaleUp: {
    hidden: { opacity: 0, scale: 0.96 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
    },
  },

  staggerContainer: {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.1, delayChildren: 0.04 },
    },
  },

  staggerContainerSlow: {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.16, delayChildren: 0.08 },
    },
  },
};

export const floatingOrb = {
  animate: {
    y: [0, -18, 0],
    x: [0, 12, 0],
    scale: [1, 1.06, 1],
  },
  transition: {
    duration: 9,
    repeat: Infinity,
    ease: 'easeInOut',
  },
};

export const floatingOrbReverse = {
  animate: {
    y: [0, 14, 0],
    x: [0, -10, 0],
    scale: [1, 1.04, 1],
  },
  transition: {
    duration: 11,
    repeat: Infinity,
    ease: 'easeInOut',
  },
};
